<template>
 
  <div id="Vue"  >
	<el-dialog
	  :title="title"
	  :visible.sync="dialogVisible1"
	  width="90%" >
	  
	  <el-table id="tb6" v-loading="loading"
		:data="people_data_array" 
		border 
		style="width: 100% " >
 
		<el-table-column
		  fixed
		  prop="full_name"
		  label="姓名"
		  width="150px">
		</el-table-column>
		<el-table-column
		  prop="job_title"
		  label="职位"
		  width="150px">
		</el-table-column>
		<el-table-column style="font-size:20px;"
		  prop="job_company_name"
		  label="公司名称" 
		  width="230px">
		</el-table-column>	
		<el-table-column style="font-size:20px;"
		  prop="job_company_website"
		  label="公司网址" 
		  width="160px">
		</el-table-column>		 	 		
		<el-table-column style="font-size:20px;"
		  prop="job_company_industry"
		  label="行业" 
		  width="160px">
		</el-table-column>

		<el-table-column 
		  label="操作" 
		  width="100" >
			 <template slot-scope="scope">
					<el-button type='success'  size="mini"   @click="handleDetail(scope.$index, scope.row)">明细</el-button> 
		  </template>
		</el-table-column>
	  </el-table>
	  <div style="margin-top:10px; display: flex; align-items:right; justify-content: flex-end;  ">
       <el-pagination @current-change="handlePageChange" :current-page="page" :page-size="10" layout="total, prev, pager, next, jumper" :total="total">
				</el-pagination> </div>
	  <span slot="footer" class="dialog-footer">
		<el-button @click="dialogVisible1 = false">取 消</el-button> 
	  </span>
	</el-dialog> 
	
 	<el-dialog
	  title="使用说明"
	  :visible.sync="dialogVisible2"
	  width="66%" >
	      <span style='font-weight:bold'>一 数据来源：</span>
		  </br>
		  <span>该数据为国外数据服务商根据各大社媒平台包括 linkedIn, facebook, twitter, github 等6亿人员的信息整理搜集而来，并且定期更新维护，通过这些数据能够精确反映一个人员的画像 . </span>
		 
		  <span>根据用户习惯, 欧美客户可以通过facebook或者邮箱与公司决策人互动，中东，东南亚等客户可以通过移动电话加whatsapp 沟通,通过这些方式能够更快与目标客户达成联系。 </span>
		  
	      </br>
	      <span style='font-weight:bold'> 二 操作方法说明：</span>
		  </br>
		  <span>1, 先选择已关注的公司信息 </span>
		  </br>
		  <span>2, 再设置人员信息，可以按照人员姓名和职位两种方法设置，职位名称可以为 owner, president, purchasing,buyer,trader 等，这样更容易找到公司决策人的信息 </span>
		  
		  </br>
	      <span style='font-weight:bold'>三 费用说明：</span>
		  </br>
		  <span>1, 每查询并匹配到一条数据扣费 5 元，匹配不到数据不扣费 </span>
		  
		  		  
		  <span slot="footer" class="dialog-footer">
			<el-button @click="dialogVisible2 = false">取 消</el-button>
			<el-button type="primary" @click="dialogVisible2 = false">确 定</el-button>
		  </span>
	</el-dialog>   
  
  <el-dialog
	  title="我关注的公司"
	  :visible.sync="dialogVisible3"
	  width="90%" >
		  <el-form ref="form"  :inline="true" :model="form" label-width="80px">
		  <el-form-item label="全球公司">
		  <el-input placeholder="请输入需查找的的公司名称" v-model="form1.companyName" style="width:300px" >
 
		  </el-input>
		  </el-form-item> 
	  
		  <el-form-item>
			<el-button type="primary" :loading="loading" @click="searchCompany" >搜索</el-button>
		  </el-form-item>
		  
		  <el-form-item style="float:right">
			<el-button type="success" :loading="loading" @click="subCompany" >已关注公司</el-button>
		  </el-form-item>
		  </el-form>
		  
	  <el-table id="tb8" v-loading="loading"
		:data="tableCompany" 
		border 
		style="width: 100% "
		max-height="430" 
		 >
 
		<el-table-column 
		  prop="company_name"
		  label="公司名称"
		  width="250px">
		</el-table-column>
		<el-table-column
		  prop="company_website"
		  label="网址"
		  width="180px">
		</el-table-column>
		<el-table-column style="font-size:20px;"
		  prop="emp_count"
		  label="职员数" 
		  width="100px">
		</el-table-column>	
		<el-table-column style="font-size:20px;"
		  prop="company_industry"
		  label="所属行业" 
		  width="160px">
		</el-table-column>		 	 		
		<el-table-column style="font-size:20px;"
		  prop="company_location"
		  label="地址" 
		  width="260px">
		</el-table-column>	
		<el-table-column style="font-size:20px;" v-if="user_id==-1"
		  prop="company_id"
		  label="公司id" 
		  width="100px">
		</el-table-column>
		<el-table-column  
		  label="操作" 
		  width="200" >
			 <template slot-scope="scope" >
					<el-button v-if="companyState==1 && scope.row.sub==0" type='success'  size="mini"  @click="handleSub(scope.$index, scope.row)">关注</el-button> 
                    <el-tag type="success" v-if="scope.row.sub==1">已关注</el-tag>
					<el-button v-if="companyState==2"  type='success'  size="mini"   @click="handleChoose(scope.$index, scope.row)">选择</el-button> 
		  </template>
		</el-table-column>
	  </el-table>
	  <div style="margin-top:10px; display: flex; align-items:right; justify-content: flex-end;  ">
       <el-pagination @current-change="handlePageChange1" :current-page="cmpyPage" :page-size="10" layout="total, prev, pager, next, jumper" :total="cmpyTotal">
				</el-pagination> </div>
	  <span slot="footer" class="dialog-footer">
		<el-button @click="dialogVisible3 = false">取 消</el-button> 
	  </span>
	</el-dialog> 
  <el-row >
  <el-col :span="22" :offset="1"> 
  

  <el-row  style=" padding:20px;margin-top:10px;background: #fff;  " justify="left"  >  <!--导航菜单-->
    <el-menu default-active="1"  mode="horizontal" @select="handleSelect" >
   
         
          <el-menu-item index="1">搜索领英数据</el-menu-item>
          <el-menu-item index="2">我关注的人员</el-menu-item>
		  <el-menu-item index="5">我关注的公司</el-menu-item>
          <el-menu-item index="3">查看示例数据</el-menu-item>
		  <el-menu-item index="4">使用说明</el-menu-item>
		  
    </el-menu>  
  </el-row>
  
  <el-row v-if="menu_index==1"  style=" padding:20px;margin-top:10px;background: #fff;  " justify="left"  >
  <el-form ref="form"  :inline="true" :model="form" label-width="80px" class="demo-form-inline">
  <el-form-item label="公司">
	  <el-input placeholder="从我关注的公司中选择" v-model="form.companyName" style="width:280px" readonly>
	 
	  </el-input>
	  <el-button type="success" :loading="loading" @click="selectCompany" plain>选择</el-button>
  </el-form-item> 
  <el-form-item label="人员">
	  <el-input :placeholder="tip2" v-model="form.peopleName" class="input-with-select">
		<el-select @change="select2Changed" v-model="peopleType" slot="prepend" placeholder="请设置人员信息" style="width:132px">
		  <el-option label="英文职位名称" value="1"></el-option> 
		  <el-option label="英文全名" value="2"></el-option>
		  
		</el-select> 
	  </el-input>
  </el-form-item>   
 
  <el-form-item>
    <el-button type="primary" :loading="loading" @click="onSubmit" >搜索</el-button>
  </el-form-item>
  
 
    
  </el-form>
  </el-row>
 
  <el-row v-loading="loading" style=" padding:20px;margin-top:10px;background: #fff;  " justify="left"  >
 
    <el-tabs v-model="activeName"  >
    <el-tab-pane label="个人信息" name="first">
	   <el-descriptions class="margin-top" title="" :column="1" border>
	 
		<el-descriptions-item>
		  <template slot="label">
			<i class="el-icon-user"></i>
			姓名： 
		  </template>
		  {{people_data.full_name}}
		</el-descriptions-item>
		<el-descriptions-item>
		  <template slot="label">
			<i class="el-icon-office-building"></i>
			 性别：
		  </template>
		   {{people_data.gender}}
		</el-descriptions-item>  
		<el-descriptions-item>
		  <template slot="label">
			<i class="el-icon-date"></i>
			 出生日期：
		  </template>
		   {{people_data.birth_year}}
		</el-descriptions-item> 
		
		<el-descriptions-item>
		  <template slot="label">
			<i class="el-icon-message"></i>
			工作邮箱： 
		  </template>
		  {{people_data.work_email}}
		</el-descriptions-item>
		<el-descriptions-item>
		  <template slot="label">
			<i class="el-icon-message"></i>
			 个人邮箱：
		  </template>
		   {{people_data.person_emails}}
		</el-descriptions-item>  
		<el-descriptions-item>
		  <template slot="label">
			<i class="el-icon-phone"></i>
			 移动电话：
		  </template>
		   {{people_data.mobile_phone}}
		</el-descriptions-item> 		
		
		<el-descriptions-item>
		  <template slot="label">
			<i class="el-icon-document"></i>
			 领英主页：
		  </template>
		   {{people_data.linkedin_url}}
		</el-descriptions-item> 
		<el-descriptions-item>
		  <template slot="label">
			<i class="el-icon-user"></i>
			 领英用户名：
		  </template>
		   {{people_data.linkedin_username}}
		</el-descriptions-item> 		
		<el-descriptions-item>
		  <template slot="label">
			<i class="el-icon-document"></i>
			 领英id：
		  </template>
		   {{people_data.linkedin_id}}
		</el-descriptions-item> 	

		<el-descriptions-item>
		  <template slot="label">
			<i class="el-icon-document"></i>
			 facebook主页：
		  </template>
		   {{people_data.facebook_url}}
		</el-descriptions-item> 
		<el-descriptions-item>
		  <template slot="label">
			<i class="el-icon-user"></i>
			 facebook用户名：
		  </template>
		   {{people_data.facebook_username}}
		</el-descriptions-item> 		
		<el-descriptions-item>
		  <template slot="label">
			<i class="el-icon-document"></i>
			 facebook id：
		  </template>
		   {{people_data.facebook_id}}
		</el-descriptions-item> 
		
		<el-descriptions-item>
		  <template slot="label">
			<i class="el-icon-document"></i>
			 twitter主页：
		  </template>
		   {{people_data.twitter_url}}
		</el-descriptions-item> 
		<el-descriptions-item>
		  <template slot="label">
			<i class="el-icon-user"></i>
			 twitter用户名：
		  </template>
		   {{people_data.twitter_username}}
		</el-descriptions-item> 		
		<el-descriptions-item>
		  <template slot="label">
			<i class="el-icon-document"></i>
			 技能：
		  </template>
		   {{people_data.skills}}
		</el-descriptions-item>  
		
		<el-descriptions-item>
		  <template slot="label">
			<i class="el-icon-phone"></i>
			 所有的电话：
		  </template>
		   {{people_data.phone_numbers}}
		</el-descriptions-item> 
		<el-descriptions-item>
		  <template slot="label">
			<i class="el-icon-message"></i>
			 所有的邮箱: 
		  </template>
		   {{people_data.emails}}
		</el-descriptions-item> 		
		
	  </el-descriptions>
	
	
	</el-tab-pane>
    <el-tab-pane label="职场信息" name="second"> 
       <el-descriptions class="margin-top" title="" :column="1" border>
		<el-descriptions-item>
		  <template slot="label">
			<i class="el-icon-user"></i>
			职位名称： 
		  </template>
		  {{people_data.job_title}}
		</el-descriptions-item>	 				 
		<el-descriptions-item>
		  <template slot="label">
			<i class="el-icon-office-building"></i>
			公司名称： 
		  </template>
		  {{people_data.job_company_name}}
		</el-descriptions-item>
		<el-descriptions-item>
		  <template slot="label">
			<i class="el-icon-mobile"></i>
			 公司网址：
		  </template>
		   {{people_data.job_company_website}}
		</el-descriptions-item>  
		<el-descriptions-item>
		  <template slot="label">
			<i class="el-icon-tickets"></i>
			 公司规模：
		  </template>
		   {{people_data.job_company_size}}
		</el-descriptions-item> 
		
		<el-descriptions-item>
		  <template slot="label">
			<i class="el-icon-date"></i>
			成立日期： 
		  </template>
		  {{people_data.job_company_founded}}
		</el-descriptions-item>
		<el-descriptions-item>
		  <template slot="label">
			<i class="el-icon-school"></i>
			 行业：
		  </template>
		   {{people_data.job_company_industry}}
		</el-descriptions-item>  
		<el-descriptions-item>
		  <template slot="label">
			<i class="el-icon-tickets"></i>
			 公司的领英主页：
		  </template>
		   {{people_data.job_company_linkedin_url}}
		</el-descriptions-item> 		
		
		<el-descriptions-item>
		  <template slot="label">
			<i class="el-icon-tickets"></i>
			 公司的facebook主页：
		  </template>
		   {{people_data.job_company_facebook_url}}
		</el-descriptions-item> 
		<el-descriptions-item>
		  <template slot="label">
			<i class="el-icon-tickets"></i>
			 公司的twitter主页：
		  </template>
		   {{people_data.job_company_twitter_url}}
		</el-descriptions-item> 		
		<el-descriptions-item>
		  <template slot="label">
			<i class="el-icon-house"></i>
			 公司的地址：
		  </template>
		   {{people_data.job_company_location_name}}
		</el-descriptions-item> 	

		<el-descriptions-item>
		  <template slot="label">
			<i class="el-icon-house"></i>
			 详细的街道信息：
		  </template>
		   {{people_data.job_company_location_street_address}}
		</el-descriptions-item> 
		<el-descriptions-item>
		  <template slot="label">
			<i class="el-icon-house"></i>
			 邮编：
		  </template>
		   {{people_data.job_company_location_postal_code}}
		</el-descriptions-item> 		
		<el-descriptions-item>
		  <template slot="label">
			<i class="el-icon-house"></i>
			 所属区域：
		  </template>
		   {{people_data.job_company_location_continent}}
		</el-descriptions-item> 
		
		<el-descriptions-item>
		  <template slot="label">
			<i class="el-icon-date"></i>
			 入职日期：
		  </template>
		   {{people_data.job_start_date}}
		</el-descriptions-item> 
		<el-descriptions-item>
		  <template slot="label">
			<i class="el-icon-date"></i>
			 职场信息更新日期：
		  </template>
		   {{people_data.job_last_updated}}
		</el-descriptions-item> 		
		 		
		
	  </el-descriptions>
	</el-tab-pane>
    <el-tab-pane label="社媒信息" name="third"> 
       
	   <el-table id="tbl2" v-loading="loading"
		:data="people_social" 
		border 
		style="width: 100%;height:600px"
		 
		 >
 
		<el-table-column
		  fixed
		  prop="network"
		  label="社媒名称"
		  width="150px">
		</el-table-column>
		<el-table-column
		  prop="network_id"
		  label="社媒 id"
		  width="150px">
		</el-table-column>
		<el-table-column style="font-size:20px;"
		  prop="url"
		  label="主页url" 
		  width="300px">
		</el-table-column>	
		<el-table-column style="font-size:20px;"
		  prop="username"
		  label="用户名" 
		  width="100px">
		</el-table-column>			
		 	

	  </el-table>
	</el-tab-pane>	
    <el-tab-pane label="工作简历" name="fourth"> 
	   <el-table id="tb3" v-loading="loading"
		:data="people_experience" 
		border 
		style="width: 100%;height:600px"
		 
		 >
 
		<el-table-column
		  fixed
		  prop="company_name"
		  label="公司名称"
		  width="150px">
		</el-table-column>
		<el-table-column
		  prop="company_size"
		  label="规模"
		  width="90px">
		</el-table-column>
		<el-table-column style="font-size:20px;"
		  prop="company_website"
		  label="公司的网址" 
		  width="100px">
		</el-table-column>	
		<el-table-column style="font-size:20px;"
		  prop="title_name"
		  label="职位名称" 
		  width="100px">
		</el-table-column>			
		<el-table-column style="font-size:20px;"
		  prop="title_role"
		  label="职位角色" 
		  width="100px">
		</el-table-column>			
		
		<el-table-column
		  prop="company_founded"
		  label="成立日期"
		  width="60px">
		</el-table-column> 	
		<el-table-column
		  prop="company_industry"
		  label="所属行业"
		  width="80px">
		</el-table-column>
		<el-table-column
		  prop="company_location"
		  label="地址"
		  width="150px">
		</el-table-column>
		<el-table-column
		  prop="company_linkedin_url"
		  label="公司的领英主页"
		  width="80px">
		</el-table-column>	
		<el-table-column
		  prop="company_facebook_url"
		  label="公司的facebook主页"
		  width="80px">
		</el-table-column>		
		<el-table-column
		  prop="company_twitter_url"
		  label="公司的twitter主页"
		  width="80px">
		</el-table-column>
		<el-table-column
		  prop="start_date"
		  label="入职日期"
		  width="80px">
		</el-table-column>		
		<el-table-column
		  prop="end_date"
		  label="离职日期"
		  width="80px">
		</el-table-column>			

	  </el-table>
	</el-tab-pane>
    <el-tab-pane label="教育简历" name="fifth">  
	   <el-table id="tb5" v-loading="loading"
		:data="people_education" 
		border 
		style="width: 100%;height:600px"
		 
		 >
 
		<el-table-column
		  fixed
		  prop="school_name"
		  label="学校名称"
		  width="150px">
		</el-table-column>
		<el-table-column
		  prop="school_type"
		  label="学校类别"
		  width="90px">
		</el-table-column>
		<el-table-column style="font-size:20px;"
		  prop="school_location"
		  label="学校的地址" 
		  width="200px">
		</el-table-column>	
		<el-table-column style="font-size:20px;"
		  prop="school_linkedin_url"
		  label="学校的领英主页" 
		  width="100px">
		</el-table-column>			
		<el-table-column style="font-size:20px;"
		  prop="school_facebook_url"
		  label="学校的facebook主页" 
		  width="100px">
		</el-table-column>	 
		<el-table-column
		  prop="school_twitter_url"
		  label="学校的twitter主页"
		  width="100px">
		</el-table-column> 	 

		<el-table-column style="font-size:20px;"
		  prop="school_website"
		  label="学校主页" 
		  width="100px">
		</el-table-column>	 
		<el-table-column
		  prop="majors"
		  label="所学专业"
		  width="100px">
		</el-table-column> 	
		<el-table-column style="font-size:20px;"
		  prop="start_date"
		  label="入学日期" 
		  width="100px">
		</el-table-column>	 
		<el-table-column
		  prop="end_date"
		  label="离学日期"
		  width="100px">
		</el-table-column> 	
		

	  </el-table>
	</el-tab-pane>	
    <el-tab-pane label="居住信息" name="sixth"> 
	   <el-table id="tb6" v-loading="loading"
		:data="people_location" 
		border 
		style="width: 100%;height:600px"
		 
		 >
 
		<el-table-column
		  fixed
		  prop="name"
		  label="城市"
		  width="250px">
		</el-table-column>
		<el-table-column
		  prop="continent"
		  label="区域"
		  width="120px">
		</el-table-column>
		<el-table-column style="font-size:20px;"
		  prop="street_address"
		  label="街道信息" 
		  width="200px">
		</el-table-column>	
		<el-table-column style="font-size:20px;"
		  prop="address_line_2"
		  label="街道信息2" 
		  width="100px">
		</el-table-column>			
		<el-table-column style="font-size:20px;"
		  prop="postal_code"
		  label="邮编" 
		  width="120px">
		</el-table-column>			
		
		<el-table-column
		  prop="geo"
		  label="经纬度"
		  width="120px">
		</el-table-column> 	 		

	  </el-table>
	</el-tab-pane>	
	
    </el-tabs>
  
  
 
  </el-row>  
  </el-col>
  </el-row>
</div>
</template>
<style>
  .el-header {
    background-color: #B3C0D1;
    color: #333;
    line-height: 60px;
  }
  
  .el-aside {
    color: #333;
  }
</style>

<script>
  
export default {
 
        data () {
            return {
	    	componentName: 'info',
			activeName: 'first',  //页面活动标志
		    userInfo: {},
			user_id: 0,
			current_key: '2',     //菜单选中标志
			dialogVisible1: false,  //我的领英数据窗口标志
			dialogVisible3: false,  //关注公司窗口标志
			title: '我的领英数据',
			people_data: {
				id : 0,
				user_id : 0,
				sysid : '',
				full_name : '',
				first_name : '',
				middle_initial : '',
				middle_name : '',
				last_initial : '',
				last_name : '',
				gender : '',
				birth_year : '',
				birth_date : '',
				linkedin_url : '',
				linkedin_username : '',
				linkedin_id : '',
				facebook_url : '',
				facebook_username : '',
				facebook_id : '',
				twitter_url : '',
				twitter_username : '',
				github_url : '',
				github_username : '',
				work_email : '',
				personal_emails : '',
				mobile_phone : '',
				industry : '',
				job_title : '',
				job_title_role : '',
				job_title_sub_role : '',
				job_title_levels : '',
				job_company_id : '',
				job_company_name : '',
				job_company_website : '',
				job_company_size : '',
				job_company_founded : '',
				job_company_industry : '',
				job_company_linkedin_url : '',
				job_company_linkedin_id : '',
				job_company_facebook_url : '',
				job_company_twitter_url : '',
				job_company_location_name : '',
				job_company_location_locality : '',
				job_company_location_metro : '',
				job_company_location_region : '',
				job_company_location_geo : '',
				job_company_location_street_address : '',
				job_company_location_address_line_2 : '',
				job_company_location_postal_code : '',
				job_company_location_country : '',
				job_company_location_continent : '',
				job_last_updated : '',
				job_start_date : '',
				location_name : '',
				location_locality : '',
				location_metro : '',
				location_region : '',
				location_country : '',
				location_continent : '',
				location_street_address : '',
				location_address_line_2 : '',
				location_postal_code : '',
				location_geo : '',
				location_last_updated : '',
				phone_numbers : '',
				emails : '',
				interests : '',
				skills : '',
				location_names : '',
				regions : '',
				countries : '',
				street_addresses : '',
				experience : '',
				education : '',
				profiles : '',
				version_status : '',
				data : '', 

			},
			
			people_data_array: [],
			people_experience: [],
			people_education: [],
			people_social: [],
			people_location: [],
			companyState: 1,
			tableCompany:[],
			loading: false,
			login_state : false, 
			menu_index: 1,
			id: 0,
			page: 0,
			cmpyPage: 1,
			cmpyTotal: 0,
			size:10,
		    total: 0,
			buttonQuery: 1,
			status:true,
			tableHeight: '600px',
			dialogVisible2: false,
			form:{  
				   companyName:'',
				   peopleName:'', 
				 },
			form1:{
			      companyName: '',
				  },
			companyType: '1',
			peopleType: '1',
			tip1:'例如 facebook.com',
			tip2:'例如 owner president purchasing buyer  ',
			tableData:[],
			}  
        },
        methods: {
			handlePageChange(val) {   //我的领英数据翻页
				this.page = val; 
				this.getData();
			},
			handlePageChange1(val) {   // 我关注的公司翻页
				this.cmpyPage = val; 
				this.myCompany();
			},			
		    handleDetail(index, row){  //领英数据明细记录
			   this.people_data = this.people_data_array[index];
			   this.people_experience = this.people_data_array[index].experience;
			   this.people_education = this.people_data_array[index].education;
			   this.people_social = this.people_data_array[index].social;
			   this.people_location = this.people_data_array[index].location;
			   this.dialogVisible1 = false;
			   this.activeName = 'first';
			   
			},
			selectCompany(){  //选择公司窗口打开
			  let that = this;
			  that.companyState = 2; //2: 选择公司  
			  that.subCompany();
			  this.dialogVisible3 = true;
			},
			handleChoose(index, row){   // 确认选择公司
			  if (row.company_website != '' && row.company_website != null){
			     this.form.companyName = row.company_website;
			     this.form.companyType = '1';			  
			     } 
			  else{
			     this.form.companyName = row.company_name;
			     this.form.companyType = '2';
			  }
			  this.dialogVisible3 = false;
			},
		    handleSub(index, row){   //关注公司

				let that = this;   
				if (that.user_id == 0 ) {
				    that.$message({
							message: '请先登录 ! ',
							type: 'success'
							});
				    return;
				}
 
					
				that.loading = true;
                $.ajax({
					  type: "POST",
					  data:  { 
							company_name: row.company_name,
							company_website: row.company_website,
							emp_count: row.emp_count,
							company_industry: row.company_industry,
							company_location: row.company_location,
							company_id: row.company_id,
							user_id: that.user_id, 
							source: 'linkedIn',
							  },
					  url: "https://www.myferp.com/admin/linkedIn/subCompany",
					  dataType: "json",  
					  beforeSend: function (request) {
						request.setRequestHeader("X-Nideshop-Token", localStorage.getItem('token') );
						},   
					  error: function(XMLHttpRequest, textStatus, errorThrown) { 
						  that.loading = false;
						  that.$message({
							message: '请求失败!',
							type: 'error'
							});
								return false;
							},             
					  success: function (data) {
						  
						  console.log(JSON.stringify(data));
						  if (data.errno == 0){
						      row.sub = 1;
						      that.$message({
							  message: '成功关注!  ',
							  type: 'success'
							  });
							  that.loading = false;	
                              that.status = true;	
							   						  
							  return;
						     } else{
						      that.$message({
							  message: '关注失败!  ',
							  type: 'error'
							  });							 
						      that.loading = false;	
                              that.status = false;
							  }
							  
						    }  
					  });
			},	
		    handleSelect(index, row){
 
			   
			},			
			getData(){
			  let that = this;
			  let user_id = 0;
			  if (that.current_key == '2'){
				       user_id = that.user_id;
					   that.title = '我的领英数据';
					   }
			  if (that.current_key == '3'){
				       user_id = 0;
					   that.title = '示例数据';
					   }
              that.loading = true;					   
			       $.ajax({
					  type: "GET",
					  data:  { 
					          page: that.page , 
							  size: 10, 
							  user_id: user_id, 
							  },
					  url: "https://www.myferp.com/admin/linkedIn/publicData",
					  dataType: "json",  
					  beforeSend: function (request) {
						request.setRequestHeader("X-Nideshop-Token", localStorage.getItem('token') );
						},   
					  error: function(XMLHttpRequest, textStatus, errorThrown) { 
						  that.loading = false;
						  that.$message({
							message: 'error',
							type: 'error'
							});
								return false;
							},             
					  success: function (data) {
						  
						  console.log(JSON.stringify(data));
						  if (data.errno != 0){
						      that.$message({
							  message: '未查询到相关数据  ',
							  type: 'error'
							  });
							  that.loading = false;	
                              that.status = true;	
							   						  
							  return;
						     }
						 
						  that.people_data_array = data.data.data ;  
					      that.page = data.data.currentPage;
						  that.total = data.data.count;
										
						  that.loading = false;	
                          that.status = false;						  
						  }
					  });
			},
		    handleSelect(key, keyPath) {
			   this.menu_index = key;
			   
			   let that = this;
			   if (key == '4'){
			      that.dialogVisible2 = true;
			   }
			   if (key == '5'){
			      that.cmpyPage = 1;
				  that.companyState = 1;
			      that.dialogVisible3 = true;
			   }			   
			   if (key == '3' || key == '2'){
			       that.people_data_array = [];
				   that.current_key = key;
			       that.dialogVisible1 = true; 
                   that.page = 1;
                   that.getData();
			   
			   }
	            			  
			},
			select1Changed(value) {
			  if (value == '1'){
			      this.tip1 = '例如 facebook.com';
				  }
			  if (value == '2'){
			      this.tip1 = '例如HONEYWELL INC';
				  } 
			  this.form.keywords = '';  
			},
			select2Changed(value) {
			  if (value == '1'){
			      this.tip2 = '例如 purchasing buyer president owner';
				  }
			  if (value == '2'){
			      this.tip2 = '例如 Donald Trump';
				  } 
			  this.form.keywords = '';  
			},
 	        searchCompany(){   //搜索公司
				if (this.form1.companyName == ''){
				    this.$message({
							message: '公司名不能为空 ! ',
							type: 'warning'
							});
				    return;
				}			    
 			
			    
				this.getCompany();
			
			},
 	        subCompany(){ //已关注公司查询 

				let that = this;   
				that.cmpyPage = 1;
				that.myCompany();
				},
            myCompany(){   //已关注公司查询				
				let that = this; 
 				if (that.user_id == 0 ) {
				    this.$message({
							message: '登录后进行查询 ! ',
							type: 'success'
							});
				    return;
				}
 			
				that.loading = true; 
				$.ajax({
					  type: "POST",
					  data:  {user_id: that.user_id,  
					          page: that.cmpyPage,
							  size: 10,       
							  },
					  url: "https://www.myferp.com/admin/linkedIn/myCompany",
					  dataType: "json",  //返回类型为 json
					  beforeSend: function (request) {
						request.setRequestHeader("X-Nideshop-Token", localStorage.getItem('token') );
						},   
					  error: function(XMLHttpRequest, textStatus, errorThrown) { 
						  that.loading = false;
						  that.$message({
							message: 'error',
							type: 'error'
							});
								return false;
							},             
					  success: function (data) {
						  
						  console.log(JSON.stringify(data));
						  if (data.errno != 0){
						      that.$message({
							  message: '未查询到相关数据  ',
							  type: 'error'
							  });
							  that.loading = false;	
                              that.status = true;	
							  that.tableCompany = []; 						  
							  return;
						     }
						 
						  that.tableCompany = data.data.data ;  
					      that.cmpyPage = data.data.currentPage;
						  that.cmpyTotal = data.data.count;
										
						  that.loading = false;	
                          that.status = false;						  
						  }
					  });
		    
			
			},			
			getCompany(){  //搜索公司
				let that = this;   
				that.loading = true;
 
				$.ajax({
					  type: "POST",
					  data:  {user_id: that.user_id,  
					          page: that.cmpyPage,
							  size: 10,   
							  companyName:that.form1.companyName, 
							   
							  },
					  url: "https://www.myferp.com/admin/linkedIn/getCompany",
					  dataType: "json",  //返回类型为 json
					  beforeSend: function (request) {
						request.setRequestHeader("X-Nideshop-Token", localStorage.getItem('token') );
						},   
					  error: function(XMLHttpRequest, textStatus, errorThrown) { 
						  that.loading = false;
						  that.$message({
							message: 'error',
							type: 'error'
							});
								return false;
							},             
					  success: function (data) {
						
						  console.log(JSON.stringify(data)); 
 
						  var info = data.data.info;
						  if (info.hasOwnProperty("status")){
						  
							  if (info.status != 200){
								  that.$message({
								  message: '未查询到相关数据，重新设置查询条件! ',
								  type: 'error'
								  });
								  that.loading = false;	
								  that.status = true;  
								  that.tableCompany = []; 
								  return;
								 }
							  that.companyState = 1;
							  that.tableCompany = data.data.tableData ; 
					          that.cmpyPage = 1;
							  
						      that.cmpyTotal = 1 ; //that.tableCompany.length;
 
						   }
						  if (info.hasOwnProperty("statusCode")){
							  if (info.statusCode >= 400){
								  that.$message({
								  message: 'code: ' + info.statusCode + ' 未查询到相关数据，重新设置查询条件! '  ,
								  type: 'error'
								  });
								  that.loading = false;	
								  that.status = true;  
								  that.tableCompany = [];						  
								  return;
								 }
						      }
						  that.loading = false;	
                          that.status = false;						  
						  }
					  });
		    },			
		    onSubmit(){  //搜索人员
				if (this.form.companyName == ''){
				    this.$message({
							message: '公司信息不能为空 ! ',
							type: 'warning'
							});
				    return;
				}			    
			 	if (this.form.peopleName == ''){
				    this.$message({
							message: '人员信息不能为空 ! ',
							type: 'warning'
							});
				    return;
				} 				
			    
				this.getInfo();
				},
			getInfo(){  //搜索人员过程
				let that = this;    
				if (that.user_id == 0 ) {
				    this.$message({
							message: '登录后进行查询 ! ',
							type: 'success'
							});
				    return;
				}  	
				that.loading = true;
				let ct = 'website';
				if (that.companyType == '2')  
                    ct = 'name';
                let pt = 'title';
				if (that.peopleType == '2')  
                    pt = 'name';
				$.ajax({
					  type: "POST",
					  data:  {user_id: that.user_id,  
							  size: 1,  
							  companyType: ct,
							  peopleType: pt,
							  companyValue:that.form.companyName,
							  peopleValue:that.form.peopleName,
							   
							  },
					  url: "https://www.myferp.com/admin/linkedIn/getPeople",
					  dataType: "json",  //返回类型为 json
					  beforeSend: function (request) {
						request.setRequestHeader("X-Nideshop-Token", localStorage.getItem('token') );
						},   
					  error: function(XMLHttpRequest, textStatus, errorThrown) { 
						  that.loading = false;
						  that.$message({
							message: 'error',
							type: 'error'
							});
								return false;
							},             
					  success: function (data) {
						
						  console.log(JSON.stringify(data)); 
						  
						  if (data.errno == 500){
						      that.$message({
								  message: '余额不足，请至会员服务充值! ',
								  type: 'error'
								  });
								  that.loading = false;	
								  that.status = true; 
								  that.people_data =  {};
								  that.people_education = [];
								  that.people_experience = [];
								  that.people_social = [];
								  that.people_location = [];
						      return;
						  }
						  var info = data.data.info;
						  if (info.hasOwnProperty("status")){
						  
							  if (info.status != 200){
								  that.$message({
								  message: '未查询到相关数据! ',
								  type: 'error'
								  });
								  that.loading = false;	
								  that.status = true; 
								  that.people_data =  {};
								  that.people_education = [];
								  that.people_experience = [];
								  that.people_social = [];
								  that.people_location = [];
								  
								  return;
								 }
							 
							  that.people_data_array = data.data.info.data ; 
							  if (that.people_data_array.length == 1){
							  	  that.$message({
								  message: '成功查询到数据，请点击我的领英数据查看! ',
								  type: 'success'
								  });
								  that.people_data = that.people_data_array[0];
								  that.people_education = that.people_data_array[0].education;
								  that.people_experience = that.people_data_array[0].experience;
								  that.people_social = that.people_data_array[0].profiles;
								  that.people_location = that.people_data_array[0].street_addresses;
								  
								  }
						   }
						  if (info.hasOwnProperty("statusCode")){
							  if (info.statusCode >= 400){
								  that.$message({
								  message: 'code: ' + info.statusCode + ' 未查询到相关数据! '  ,
								  type: 'error'
								  });
								  that.loading = false;	
								  that.status = true; 
								  that.people_data =  {};
								  that.people_education = [];
								  that.people_experience = [];
								  that.people_social = [];
								  that.people_location = [];						  
								  return;
								 }
						      }
						  that.loading = false;	
                          that.status = false;						  
						  }
					  });
		    },
			
			login()
			{
			  this.$router.push({
					path: '/login',
					params: {
					  sometext: ''
					}
				  }); 
			},

			back()
			{ 
			  this.$router.push({
					path: '/home/index',
					params: {
					  sometext: ''
					}
				  });  
			},
 

		},
        mounted() { 
			  //判断登录状态 
			let userInfo = localStorage.getItem('userInfo');
			console.log( 'user:' + typeof userInfo);  
			if (userInfo == '' || userInfo == null  || typeof userInfo == undefined ){
				    this.login_state = false;
				}else{
				    this.login_state = true;
					let info = JSON.parse(userInfo);
				    let user_id = info.id; 
                    this.user_id = user_id;		
				}
           },		   
		
    } ;

</script>
 


// WEBPACK FOOTER //
// src/components/customs/peopleSearch.vue